/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Provisioning_Partner_Code_Required_For_Master_PasskeyInputs */

const es_co2_error_provisioning_partner_code_required_for_master_passkey = /** @type {(inputs: Error_Provisioning_Partner_Code_Required_For_Master_PasskeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un destino para continuar.`)
};

/**

* @param {Error_Provisioning_Partner_Code_Required_For_Master_PasskeyInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_provisioning_partner_code_required_for_master_passkey = /** @type {((inputs?: Error_Provisioning_Partner_Code_Required_For_Master_PasskeyInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Provisioning_Partner_Code_Required_For_Master_PasskeyInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_provisioning_partner_code_required_for_master_passkey(inputs)
});